let defaultAgendadoForm = {
    fechaAgendado: '',
    notas: '',
}

export default defaultAgendadoForm